import { useEffect, useState } from "react";

export const useIsSSR = (): boolean => {
    const [isSSR, setIsSSR] = useState(true);

    useEffect(() => {
        setIsSSR(false);
    }, []);

    return isSSR;
};

/**
 * Convert SSR-serialized data to client-side types.
 *
 * This handles the boundary issue between:
 * - Template serialization: plain strings, unbranded types
 * - API responses / client types: branded types (e.g., ImageURL)
 *
 * Using structuredClone ensures we get a mutable deep copy that won't conflict
 * with Immer's immutability expectations from Reactivated props.
 *
 * @param data - SSR data from Reactivated template props
 * @returns Deep clone cast to the target type
 *
 * @example
 * const gridData = fromSSRData<GridItem[]>(props.initialGridData);
 * const posts = fromSSRData<UGCListSubBlock[]>(initialGridData);
 */
export function fromSSRData<T>(data: unknown): T {
    return structuredClone(data) as T;
}
